import axios from "axios";
import { GURL } from "./global";

export const CreateCategories = (f: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  return axios.post(`${GURL}/Notice/v1/Category/create`, f);
};

export const GetAllCategories = () => {
  const url = `${GURL}/Notice/v1/Category`;
  //console.log(url);
  return axios.get(url);
};

export const GetCategorySelectListVm = () => {
  const url = `${GURL}/Notice/v1/Category/GetCategorySelectListVm`;
  //console.log(url);
  return axios.get(url);
};

export const GetCategoryById = (id: any) => {
  const url = `${GURL}/Notice/v1/Category/GetCategoriesById?categoryId=${id}`;
  //console.log(url);
  return axios.get(url);
};

export const GetCategoryByParentId = (id: any) => {
  if (id != null) {
    const url = `${GURL}/Notice/v1/Category/GetCategoriesByParentId?categoryId=${id}`;
    return axios.get(url);
  } else {
    const url = `${GURL}/Notice/v1/Category/GetCategoriesByParentId?categoryId=`;
    return axios.get(url);
  }
};
